export const categories = [
  {
    id: 'japan-culture',
    name: '日本文化',
    slug: 'japan-culture',
    description: '探索日本传统文化、茶道、花道、和服、节日庆典等丰富文化内涵',
    icon: 'ri-building-2-line',
    articleCount: 42,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20culture%20scene%20with%20tea%20ceremony%20utensils%20and%20kimono%20fabric%20in%20warm%20natural%20lighting%2C%20minimalist%20wooden%20interior%2C%20cream%20and%20earth%20tones%2C%20soft%20shadows%2C%20editorial%20photography&width=800&height=600&seq=cat-culture-01&orientation=landscape'
  },
  {
    id: 'japan-film',
    name: '日本影视',
    slug: 'japan-film',
    description: '涵盖日本电影、电视剧、动画电影等优质影视作品推荐与深度解析',
    icon: 'ri-film-line',
    articleCount: 56,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20cinema%20aesthetic%20with%20vintage%20film%20projector%20and%20movie%20posters%20in%20warm%20amber%20lighting%2C%20nostalgic%20atmosphere%2C%20cream%20and%20terracotta%20tones%2C%20editorial%20photography&width=800&height=600&seq=cat-film-01&orientation=landscape'
  },
  {
    id: 'japan-food',
    name: '日本美食',
    slug: 'japan-food',
    description: '从寿司拉面到和果子，全方位介绍日本料理文化与美食探店指南',
    icon: 'ri-restaurant-line',
    articleCount: 38,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20cuisine%20beautifully%20arranged%20sushi%20and%20ramen%20on%20wooden%20table%2C%20warm%20natural%20lighting%2C%20minimalist%20composition%2C%20cream%20and%20earthy%20tones%2C%20editorial%20food%20photography&width=800&height=600&seq=cat-food-01&orientation=landscape'
  },
  {
    id: 'japan-travel',
    name: '日本旅游',
    slug: 'japan-travel',
    description: '日本热门目的地攻略、交通指南、住宿推荐等一站式旅行资讯',
    icon: 'ri-map-pin-line',
    articleCount: 64,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20landscape%20with%20cherry%20blossom%20trees%20and%20traditional%20temple%20architecture%2C%20warm%20golden%20hour%20lighting%2C%20peaceful%20atmosphere%2C%20cream%20and%20soft%20pink%20tones%2C%20travel%20photography&width=800&height=600&seq=cat-travel-01&orientation=landscape'
  },
  {
    id: 'japan-anime',
    name: '日本动漫',
    slug: 'japan-anime',
    description: '经典与热门动漫作品推荐、角色分析、产业动态与二次元文化',
    icon: 'ri-palette-line',
    articleCount: 71,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20art%20style%20illustration%20with%20warm%20color%20palette%2C%20creative%20studio%20setting%20with%20sketchbooks%20and%20art%20supplies%2C%20cream%20and%20soft%20coral%20tones%2C%20editorial%20composition&width=800&height=600&seq=cat-anime-01&orientation=landscape'
  },
  {
    id: 'japan-music',
    name: '日本音乐',
    slug: 'japan-music',
    description: 'J-POP、演歌、传统音乐等日本音乐流派介绍与艺人推荐',
    icon: 'ri-music-line',
    articleCount: 29,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20traditional%20musical%20instruments%20shamisen%20and%20koto%20in%20warm%20natural%20lighting%2C%20minimalist%20wooden%20room%2C%20cream%20and%20earth%20tones%2C%20editorial%20still%20life%20photography&width=800&height=600&seq=cat-music-01&orientation=landscape'
  },
  {
    id: 'japan-fashion',
    name: '日本时尚',
    slug: 'japan-fashion',
    description: '东京街头潮流、原宿风格、日系穿搭灵感与设计师品牌解读',
    icon: 'ri-t-shirt-line',
    articleCount: 33,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20contemporary%20fashion%20with%20minimalist%20clothing%20display%20on%20wooden%20racks%2C%20warm%20natural%20lighting%2C%20cream%20and%20soft%20beige%20tones%2C%20editorial%20fashion%20photography&width=800&height=600&seq=cat-fashion-01&orientation=landscape'
  },
  {
    id: 'japan-tech',
    name: '日本科技',
    slug: 'japan-tech',
    description: '日本前沿科技创新、电子产品、机器人技术与数码产品资讯',
    icon: 'ri-cpu-line',
    articleCount: 25,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20modern%20technology%20minimalist%20gadget%20display%20with%20warm%20ambient%20lighting%2C%20clean%20wooden%20desk%2C%20cream%20and%20soft%20grey%20tones%2C%20editorial%20product%20photography&width=800&height=600&seq=cat-tech-01&orientation=landscape'
  }
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((cat) => cat.slug === slug);
};